module.exports = __webpack_public_path__ + "static/media/ilkley-26.9b67ef72.jpg";